export default "__VITE_ASSET__DoUrw0C1__"